"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootReducer = exports.rootInitialState = void 0;
const redux_1 = require("redux");
const TransactionSigningReducer_1 = require("@/features/transaction-signing/reducers/TransactionSigningReducer");
const login2FAReducer_1 = require("@/features/login2fa/reducers/login2FAReducer");
exports.rootInitialState = {
    transactionSigning: TransactionSigningReducer_1.transactionSigningInitialState,
    login2FA: login2FAReducer_1.initialLoing2FAState
};
const rootReducer = (history) => (0, redux_1.combineReducers)({
    transactionSigning: TransactionSigningReducer_1.transactionSigningReducer,
    login2FA: login2FAReducer_1.login2FAReducer
});
exports.rootReducer = rootReducer;
